import React from 'react'
import PropTypes from 'prop-types'
import { Link } from 'gatsby'
import styled from 'styled-components'

import logoShadow from '../images/logo-shadow.png'

const LogoLink = styled(Link)`
  display: inline-block;
  line-height: 0;
  margin-bottom: 1.5rem;
`

const Logo = styled.img`
  height: 64px;
  width: auto;
  margin: 0;
  display: block;
`

const ContentWrapper = styled.article`
  max-width: 820px;
  margin: 2rem auto;
  padding: 2rem 2.5rem;
  color: #1a1a1a;
  line-height: 1.55;
  font-family: -apple-system, BlinkMacSystemFont, Segoe UI, Roboto, Oxygen,
    Ubuntu, Cantarell, Fira Sans, Droid Sans, Helvetica Neue, sans-serif;

  h1, h2, h3, h4, h5, h6 {
    color: #1a1a1a;
  }

  a {
    color: #1a4f9b;
  }

  strong {
    color: #1a1a1a;
  }

  ul, ol {
    margin-left: 1.45rem;
  }

  @media (max-width: 600px) {
    margin: 1rem;
    padding: 1.25rem;
  }
`

const LegalLayout = ({ children }) => (
  <ContentWrapper>
    <LogoLink to="/" aria-label="Wiltshire Jones home">
      <Logo src={logoShadow} alt="Wiltshire Jones logo" />
    </LogoLink>
    {children}
  </ContentWrapper>
)

LegalLayout.propTypes = {
  children: PropTypes.node.isRequired,
}

export default LegalLayout
